<script lang="ts">
    import { Button } from 'sveltestrap'
    import Card from "../../Core/Card.svelte";
    import data from "../../../Data/ComponentData/BonusUi/BonusUi.json"
    import { OutlineSmallbuttons, OutlineSmallbuttonsMessage, PrimaryButton } from '../../../utils/Constant/Constant';
</script>
  
<Card headerTitle={OutlineSmallbuttons} cardHeaderprops="pb-0" cardBodyprops="btn-showcase">
    <div slot="customheader" >
      <span>{@html OutlineSmallbuttonsMessage} </span>
    </div>
    <div slot="contentbody">
        <Button outline color="primary" size="sm">{PrimaryButton}</Button>
        {#each data.buttoncolordata as buttonItem}
          <Button outline color={buttonItem.color} size="sm">
            {buttonItem.title} Button
          </Button>
        {/each}
    </div>
</Card>
  